import { RichText } from '@sitecore-jss/sitecore-jss-nextjs';
import React, { useEffect, useRef, useState } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import IsRtl from 'components/Shared/isRtl';
import axios from 'axios';
import Link from 'next/link';
// import { extractRelativeURLPath } from 'components/Shared/DomainSplit';
import { A11y, Pagination } from 'swiper';
import { DGACarouselArrow } from 'components/Shared/dga-carousel-arrow/DGACarouselArrow';
import { DGAButton } from 'components/Shared/dga-button/DGAButton';
import sanitizeHref from 'lib/UrlSanitization/UrlSanitization';

type ResDataItem = {
     Id: string;
    Title: string;
    Description: string;
    Sector: string;
    SectorId: string;
    Visits: number;
    itemPath: string;

};

type PopuarOrReltaedProps = {
    Title: string;
    isPopularService :boolean;
    Lang : string;
    DetailPageLink : {
        value: {
            href: string;
            target: string;
        }
    };
    sectorId? : string;
    serviceId?: string;
    ViewDetailBtnText : {
        value: string;
    };
}
function PopularOrRelatedItems(props: PopuarOrReltaedProps) {
    const swiperRef = useRef<any>(null);
    const [ListData, setListData] = useState<ResDataItem[]>([]);
    const [controlledSwiper, setControlledSwiper] = useState<any>(null);
    const [isBeginning, setIsBeginning] = useState(true);
    const [isEnd, setIsEnd] = useState(false);

    const getPopularServices = async () => {

        try {
            const res = await axios({
                url: `${process.env.NEXT_PUBLIC_SITECORE_REST}/api/Service/GetPopularServices`,
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                data: {

                    culture: props?.Lang,
                },
            });
            setListData(res?.data);
        } catch (_error) {
            // Handle error
        }
    };
    const getRelatedServices = async () => {
    if(props?.sectorId && props?.serviceId){
      try {
        const res = await axios({
            url: `${process.env.NEXT_PUBLIC_SITECORE_REST}/api/Service/GetRelatedServices`,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            data: {
                sectorId: props?.sectorId,
                serviceId:props?.serviceId,
                culture: props?.Lang,
            },
        });
        setListData(res?.data);
      } catch (_error) {
        // Handle error
      }
    }

    };

    useEffect(() => {
        if (props?.isPopularService) {
            getPopularServices()
        }else{

            getRelatedServices()
        }

    }, [props?.Lang, props?.isPopularService,props])


    return (
        <div>
    {(ListData?.length > 0) &&    <div className={`w-full  ${ props?.isPopularService ? 'bg-[#F3F4F6]' : 'bg-[#F3F4F6]'}  md:py-10 md:px-10 py-10 px-5 ${props?.Lang == 'en'? 'ltr':'rtl'}`}>
               <div className='responsive'>
               <div className='flex flex-row gap-3 mb-10'>
                    <h2 className='animate-top-dga flex-1 flex text-[30px] lg:text-[30px] 2xl:text-[35px] font-bold text-start'>{props?.Title}</h2>

                </div>
                <div className='w-full relative'>
                    <Swiper

                        slidesPerView={1.1}
                        spaceBetween={20}
                        className="mySwiper !overflow-hidden !pb-10 relative related-service"
                        ref={swiperRef}
                        modules={[Pagination, A11y]}
                        pagination={{ clickable: true,  el: "#related-service-pagination" }}
                        a11y={{
                          enabled: true,
                          paginationBulletMessage: "Go to slide {{index}}",
                        }}
                        onInit={(ev:any)=>{
                          setControlledSwiper(ev as any)
                          setIsBeginning(ev.isBeginning);
                          setIsEnd(ev.isEnd);
                         }}
                        onSlideChange={(swiper) => {
                            setIsBeginning(swiper.isBeginning);
                            setIsEnd(swiper.isEnd);
                        }}
                        breakpoints={{
                            768: {
                                slidesPerView: 3,
                                spaceBetween: 30,
                            }
                        }}
                    >
                        {(ListData?.length > 0) && ListData?.map((item: ResDataItem, index: any) => {
                            return (
                                <SwiperSlide className='cursor-pointer overflow-hidden !h-auto' key={index}>
                                    <Link  href={sanitizeHref(item?.itemPath)} target={props?.DetailPageLink?.value?.target} className='h-full block'>
                                        <div className= 'animate-top-dga w-full h-full flex justify-between flex-col gap-5 md:gap-5 lg:gap-15 bg-white p-6 min-h-[308px] border-[#D2D6DB] border-[1px] rounded-2xl'>
                                            <div className='flex flex-1 flex-col gap-4'>
                                                <h3 className='text-[#2E2E2E] font-semibold text-[18px]  text-start line-clamp-2 ' title={item?.Title}>{item?.Title}</h3>
                                                <RichText className="text-[#919191] font-normal text-start text-[16px]   line-clamp-4" field={{ value: item?.Description || ((props?.Lang == 'en')? 'Add service description': 'أضف وصف الخدمة') }} />
                                            <div className='w-fit bg-[#F9FAFB] text-xs px-1 py-1 text-center rounded-lg border-[1px] border-[#E5E7EB]'>
                                                <p className='text-[#1F2A37]' >{ item?.Sector }</p>
                                            </div>
                                            </div>

                                            {props?.ViewDetailBtnText?.value && <div className={`w-fit  text-[12px] xl:text-[14px]  py-2`}>
                                                <DGAButton type="submit" buttonContent={props?.ViewDetailBtnText?.value}
                                                                                   size="lg" variant='secondarySolid' />
                                            </div>}
                                        </div>
                                    </Link>
                                </SwiperSlide>
                            )
                        })}


                    </Swiper>
                    {ListData?.length > 3  && <div className='relative  gap-2 justify-end hidden md:flex'>
                        {/* Arrow Left */}
                         <DGACarouselArrow
                              onClick={() => {
                                controlledSwiper?.slidePrev();
                              }}
                              direction={IsRtl() ? "right" : "left"}
                              size="large"
                              style="primary"
                              disabled={isBeginning}
                          />

                        {/* Arrow Right */}
                        <DGACarouselArrow
                              direction={IsRtl() ? "left" : "right"}
                              size="large"
                              style="primary"
                              onClick={() => {
                                controlledSwiper?.slideNext();
                              }}
                              disabled={isEnd}
                        />
                    </div>}
                    <div id="related-service-pagination" className={`md:!w-fit custom_swiper mx-auto md:mx-0 absolute ${IsRtl() ? '!right-0' : '!left-0'} !bottom-[-20px]  md:!bottom-0 !justify-center !gap-[2px]`}   />

                </div>
               </div>


            </div>}



        </div>
    )
}

export default PopularOrRelatedItems